export default "__VITE_ASSET__Dw$PxdMn__"